import { Route } from "react-router-dom"
import { WebsiteLayout } from "../layouts/WebsiteLayout"
import { Home } from "../pages/Home"
import { Login } from "../pages/Login"
import { Register } from "../pages/Register"
import { Cart } from "../pages/Cart"
import { Orders } from "../pages/Orders"
import { TagProducts } from "../pages/TagProducts"
import { ProductDetail } from "../pages/ProductDetail"

export const websiteRoutes = (
  <Route path="/website" element={<WebsiteLayout />}>
    <Route index element={<Home />} />
    <Route path="home" element={<Home />} />
    <Route path="login" element={<Login />} />
    <Route path="register" element={<Register />} />
    <Route path="cart" element={<Cart />} />
    <Route path="orders" element={<Orders />} />
    <Route path="orders/:id" element={<Orders />} />
    <Route path="tag/:id" element={<TagProducts />} />
    <Route path="product/:id" element={<ProductDetail />} />
  </Route>
)
